import "./logo.css";

const Logo = () => {
  // return <img src={logo} alt="jobster logo" className="logo" />;
  return <div className="main-logo logo">Mhh</div>;
};
export default Logo;
